<template>
  <div id="app">
    <!-- 登录页独立渲染 -->
    <router-view v-if="$route.path === '/login'"/>

    <!-- 主界面（非登录页） -->
    <el-container
        v-if="$route.path !== '/login'"
        class="app-container"
        direction="vertical"
    >
      <show-big-all v-if="bigshow && !bigshowxs" @bigshowfh="bigshowfh" @bigshowxsjs="bigshowxsjs"></show-big-all>
      <show-big-xs v-if="bigshow && bigshowxs" @bigshowptjs="bigshowxsjs1"></show-big-xs>
      <!-- 顶部固定导航栏 -->
      <el-header class="app-header" v-if="!bigshow">
        <Navbar @menu-select="handleMenuSelect" @upqwe="updateqwe" @showbig="showbig"/>
      </el-header>
      <el-dialog title="修改密码" :visible.sync="dialogFormVisible" style="z-index: 9999" id="upqwe"
                 :close-on-press-escape="false" :close-on-click-modal="false">
        <el-form ref="form" :model="form" id="scfrom" label-width="130px">
          <div style="    text-align: center;
    padding-bottom: 20px;"><span v-if="istop==1" style="color: red;">初次进入系统需要修改初始化密码</span></div>
          <el-form-item label="原始密码" prop="name" v-if="istop!=1">
            <el-input v-model="form.password" type="password" show-password autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="新密码">
            <el-input v-model="form.password1" type="password" show-password autocomplete="new-password"></el-input>
          </el-form-item>

          <el-form-item label="确认密码" prop="contacts">
            <el-input v-model="form.password2" autocomplete="new-password" show-password type="password"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button v-if="this.istop!=='1'" @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="SubmitSc">提 交</el-button>
        </div>
      </el-dialog>
      <!-- 主体内容区 -->
      <el-container v-if="!bigshow" class="app-body">

        <!-- 左侧二级菜单（可收起/隐藏） -->
        <el-aside
            v-if="showleft"
            :width="showleft?'240px':'0px'"
            class="app-aside"
        >
          <RouterNav :dqmk1="currentModule"/>
        </el-aside>

        <!-- 主内容区域 -->
        <el-main class="app-main">
          <!-- 欢迎页 / 大屏首页（issy === 0） -->
          <!-- 欢迎页 / 大屏首页（issy === true） -->
          <div v-if="issy" class="welcome-page" style="padding-top: 0px;padding-bottom: 0px">
            <!-- 公共头部：用户名 -->
            <h1>{{ isMobile ? '欢迎使用移动端' : '欢迎使用系统' }}</h1>
            <!--
                        <p class="user-info">当前用户：{{ username || '访客' }}</p>
            -->

            <!-- 手机端：4 个功能入口 -->
            <div v-if="isMobile" class="mobile-functions">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-card class="func-card" shadow="hover" @click.native="$message.warning('暂不开放')">
                    <div class="card-content">
                      <i class="el-icon-upload2 func-icon"></i>
                      <h3>快速入库</h3>
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="12">
                  <el-card shadow="hover" class="func-card" @click.native="checkPrower('wlck')">
                    <div class="card-content">
                      <i class="el-icon-download func-icon"></i>
                      <h3>快速出库</h3>
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="12" style="padding-top: 30px;">
                  <el-card shadow="hover" class="func-card" @click.native="checkPrower('wlsy')">
                    <div class="card-content">
                      <i class="el-icon-search func-icon"></i>
                      <h3>信息查询</h3>
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="12" style="padding-top: 30px;">
                  <el-card shadow="hover" class="func-card" @click.native="checkPrower('cm')">
                    <div class="card-content">
                      <i class="el-icon-more func-icon"></i>
                      <h3>更多功能</h3>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
            </div>

            <!-- 电脑端：仪表盘统计卡片 -->
            <div v-else class="dashboard-placeholder" v-if="1==2">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-card shadow="hover">
                    <div class="card-content">
                      <h3>项目总数</h3>
                      <p class="number">128</p>
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="8">
                  <el-card shadow="hover">
                    <div class="card-content">
                      <h3>待审数量</h3>
                      <p class="number">42</p>
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="8">
                  <el-card shadow="hover">
                    <div class="card-content">
                      <h3>今日活跃</h3>
                      <p class="number">356</p>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
            </div>
          </div>

          <!-- 实际路由页面内容（issy === 1） -->
          <router-view v-if="!issy"/>
        </el-main>
      </el-container>

    </el-container>
  </div>
</template>

<script>
import Navbar from './navbar/navbar.vue'
import RouterNav from './router-nav/router-nav.vue'
import ShowBigAll from "@/views/showbig/showBigAll.vue";
import ShowBigXs from "@/views/showbig/showBigXs.vue";

export default {
  name: 'App',
  components: {
    ShowBigXs,
    ShowBigAll,
    Navbar,
    RouterNav
  },
  data() {
    return {
      bigshowxs: false,
      bigshow: false,
      istop: 0,
      dialogFormVisible: false,
      form: {
        password: '',
        password1: '',
        password2: ''
      },
      username: localStorage.getItem('username') || '',
      currentModule: '',      // 当前选中的模块标识，如 'xtgl', 'kyxm' 等
      showleft: false,       // 是否显示左侧菜单
      issy: false,     // 是否显示 <router-view>（代替原来的 issy）
      isMobile: false
    }
  },
  computed: {},

  created() {
    this.checkLoginStatus();
    this.checkDevice()
    this.restoreMenuStateFromRoute();
    this.getupqweDialog()
    console.log(this.showleft)
  },
  methods: {
    bigshowfh(str) {
      if (str) {
        this.bigshow = false
      }

    },
    bigshowxsjs(str) {

      if (str) {
        this.bigshowxs = true
      } else {
        this.bigshowxs = false
      }
    },
    bigshowxsjs1(str) {

      if (str) {
        this.bigshow = false
      } else {
        this.bigshowxs = false
      }
    },

    getupqweDialog() {
      this.istop = localStorage.getItem('istop');
      if (this.istop === '1') {
        this.dialogFormVisible = true
      }
    },

    checkPrower(permission) {
      const qx = localStorage.getItem('qx');
      if (qx && qx.includes(permission)) {
        if (permission == 'wlck') {
          this.$router.push('/kcgl/ksck');
          this.issy = false;
        } else if (permission == 'wlsy') {
          this.$router.push('/kcgl/query');
          this.issy = false;
        }
      } else {
        let user = localStorage.getItem('user')
        const users = ['zhangh', 'lisl', 'daiqq', 'fengzj']
        if (permission == 'cm' && users.includes(user)) {
          this.$router.push('/kcgl/cmQuery');
          this.issy = false;
        } else {
          this.$message.warning('您无权限，请联系管理员');
        }
      }
      ;
    },
    // 新增方法：根据当前路由恢复菜单状态
    restoreMenuStateFromRoute() {
      const currentPath = this.$route.path;
      // 首页特殊处理
      if (currentPath === '/' || currentPath === '/home') {
        this.showleft = false;
        this.issy = true;
        this.currentModule = '';
        return;
      }
      if (currentPath === '/queryAll') {
        this.showleft = false;
        this.issy = false; // 必须为 false，否则不渲染内容
        return;
      }
      // 路由 → 模块键 反向映射
      const pathToModule = {
        '/kcgl/ksck': 'ksck',
        '/kcgl/ksrk': 'ksrk',
        '/kcgl/query': 'query',
        '/system/userList': 'user',
        '/system/operationLog': 'xtgl',
        '/basic/productManage': 'jbgn',
        // 继续添加你的其他路由...
      };

      // 查找当前路径对应的模块 key
      const matchedModule = Object.keys(pathToModule).find(path =>
          currentPath.startsWith(path)
      );

      if (matchedModule) {
        const moduleKey = pathToModule[matchedModule];
        this.currentModule = moduleKey;

        // 特殊模块隐藏左侧菜单
        if (moduleKey === 'ksck' || moduleKey === 'ksrk') {
          this.showleft = false;
        } else {
          this.showleft = true;
        }
        this.issy = false;
      } else {
        // 没匹配到，默认为隐藏左侧（如 404 页）
        this.showleft = false;
        this.issy = true;
      }
      if (currentPath.startsWith('/system/')) {
        this.currentModule = 'xtgl';
        this.showleft = true;
        this.issy = false;
        return;
      }
      if (currentPath.startsWith('/basic/')) {
        this.currentModule = 'jbgn';
        this.showleft = true;
        this.issy = false;
        return;
      }
    },

    // 处理 Navbar 传来的菜单选择事件（原来叫 upsy）
    handleMenuSelect(moduleKey) {
      console.log('handleMenuSelect')
      if (moduleKey === 'sy') {
        // 返回首页/欢迎页
        this.$router.replace('/')
        this.showleft = false
        this.issy = true
        this.currentModule = ''
        return
      }
      // 其他模块 → 显示菜单 + 内容

      this.currentModule = moduleKey

      // 根据模块跳转对应路由
      const routeMap = {
        ksck: '/kcgl/ksck',
        ksrk: '/kcgl/ksrk',
        query: '/kcgl/query',
        xtgl: '/system/operationLog',
        jbgn: '/basic/productManage'

        // 可继续添加其他模块
      }

      const targetPath = routeMap[moduleKey]
      if (targetPath) {
        console.log(moduleKey)
        debugger;
        // 特殊处理：某些模块需要全屏（左侧隐藏）

        if (moduleKey === 'ksck') {
          this.showleft = false
          this.issy = false
        } else if (moduleKey === 'ksrk') {
          this.showleft = false
          this.issy = false
        } else {
          this.showleft = true
          this.issy = false
        }

        this.$router.push(targetPath)
      }
    },
    updateqwe(key) {
      if (key) {
        this.dialogFormVisible = true
      }
    },
    showbig(key) {
      if (key) {
        this.bigshow = true
      }
    },
    SubmitSc() {
      if (this.form.password1 === this.form.password2) {
        let user = {username: localStorage.getItem('user'), password: this.form.password1, nickname: this.form.password}
        this.$request.postHttp({
          url: "/api/auth/upqwe",
          data: JSON.stringify(user),
          success: (data) => {
            if (data.code == 200) {
              this.$message.success(data.msg)
              this.dialogFormVisible = false
              localStorage.setItem("istop", 0);
            } else {
              this.$message.warning(data.msg)
            }


          },
          error: (error) => {
            console.error("Error:", error);
            // 执行失败时的操作
          },
        })
      } else {
        this.$message.warning('新密码两次输入不一致');
      }
    },
    checkDevice() {
      const ua = navigator.userAgent.toLowerCase();

      // 常见移动端标识
      const isMobile = /mobile|android|iphone|ipad|ipod|windows phone|kindle|silk|blackberry|opera mini|iemobile/i.test(ua);

      // 更精确一点（可选）
      const isTablet = /ipad|tablet|playbook|silk/i.test(ua);
      if (this.$route.path === '/system/operationLog') {
        this.showleft = true
        this.issy = false
      }
      if (isMobile && !isTablet) {
        this.isMobile = true;
        // 可以存 localStorage 或 Vuex/Pinia
        localStorage.setItem('deviceType', 'mobile');
      } else if (isTablet) {
        this.isMobile = true; // 或单独处理平板
      } else {
        this.isMobile = false;
        localStorage.setItem('deviceType', 'pc');
      }

      // 可选：根据设备调整布局
    },
    checkLoginStatus() {
      const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true'


      if (!isLoggedIn && this.$route.path !== '/login') {
        this.$router.replace('/login')
      }

      if (isLoggedIn && this.$route.path === '/login') {
        this.$router.replace('/')
      }

    },

    // 可选：登出方法（你原来有）
    handleLogout() {
      this.$confirm('确定退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        localStorage.removeItem('isLoggedIn')
        localStorage.removeItem('username')
        this.$message.success('已退出')
        this.$router.push('/login')

      })
    }
  }
}
</script>
<style>
/* 全局重置 */
html, body {
  margin: 0 !important;
  padding: 0 !important;
  height: 100%;
  overflow: hidden;
}

#app {
  height: 100vh;
  overflow: hidden;
}
</style>
<style scoped>
/* 欢迎页公共样式 */
.welcome-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  text-align: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.welcome-page h1 {
  margin-bottom: 20px;
  color: #ef6c00;
  font-size: 2.2rem;
}

.user-info {
  font-size: 1.1rem;
  color: #606266;
  margin-bottom: 40px;
}

/* 手机端功能入口 */
.mobile-functions {
  width: 100%;
  max-width: 500px;
}

.func-card {
  height: 140px;
  cursor: pointer;
  transition: all 0.3s;
}

.func-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
}

.func-icon {
  font-size: 48px;
  color: #FF8C00;
  margin-bottom: 12px;
}

.func-card .card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.func-card h3 {
  margin: 0;
  font-size: 1.2rem;
  color: #303133;
}

/* 电脑端仪表盘 */
.dashboard-placeholder {
  width: 100%;
  max-width: 1200px;
  margin-top: 40px;
}

.card-content {
  text-align: center;
}

.card-content h3 {
  margin: 0 0 12px;
  font-size: 16px;
  color: #606266;
}

.card-content .number {
  font-size: 48px;
  font-weight: bold;
  color: #FF8C00;
  margin: 8px 0 0;
}

.app-container {
  height: 100vh;
  overflow: hidden;
}

.app-header {
  height: 60px !important;
  padding: 0;
  background: #ffffff;
  border-bottom: 1px solid #dcdfe6;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.app-body {
  height: calc(100vh - 60px);
  margin-top: 60px;
}

.app-aside {
  background: #304156;
  color: #fff;
  overflow-y: auto;
  transition: width 0.28s;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
}

.app-main {
  background: #f0f2f5;
  padding: 20px;
  overflow-y: auto;
  height: 100%;
}

/* 欢迎页样式 */
.welcome-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 60px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  text-align: center;
}

.welcome-page h1 {
  margin-bottom: 20px;
  color: #ffffff;
}

.dashboard-placeholder {
  width: 100%;
  max-width: 1200px;
  margin-top: 40px;
}

.card-content {
  text-align: center;
}

.card-content h3 {
  margin: 0 0 12px;
  font-size: 16px;
  color: #606266;
}

.card-content .number {
  font-size: 36px;
  font-weight: bold;
  color: #409eff;
}

/* 全局容器 */
#app, .app-container {
  height: 100vh;
  overflow: hidden;
  background: #ffffff; /* 纯白底色 */
}

/* 顶部导航栏：橙黄渐变 */
.app-header {
  height: 64px !important;
  background: linear-gradient(90deg, #FF8C00, #FFB74D) !important;
  color: white;

  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* 主体区域 */
.app-body {
  height: calc(100vh - 64px);
  margin-top: 60px;
  display: flex;
  overflow: hidden;
}

/* 左侧二级菜单（RouterNav） */
.app-aside {
  width: 240px;
  background: #fff8e1; /* 极浅暖黄，温和不刺眼 */
  border-right: 1px solid #ffe082;
  overflow-y: auto;
  transition: width 0.3s;
}

/* 主内容区 */
.app-main {
  flex: 1;
  background: #ffffff; /* 纯白内容区 */
  padding: 0px 24px 24px 24px;
  overflow-y: auto;
}

/* 欢迎页 / 首页大屏 */
.welcome-page {
  height: 100%;
  text-align: center;
  padding-top: 80px;
  color: #333333;
}

.welcome-page h1 {
  color: #ef6c00; /* 深橙标题 */
  margin-bottom: 20px;
}

/* 仪表盘卡片 */
.dashboard .el-card {
  border: 1px solid #ffe082;
  box-shadow: 0 4px 16px rgba(255, 193, 7, 0.12);
  transition: all 0.2s;
}

.dashboard .el-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(255, 193, 7, 0.18);
}

.num {
  font-size: 36px;
  font-weight: bold;
  color: #FF8C00; /* 主橙色数字 */
  margin: 12px 0 0;
}

/* 菜单高亮（在 RouterNav 组件里也可以加） */
.menu-item.active,
.menu-item:hover {
  background: #fff3e0 !important;
  color: #e65100 !important;
}

#upqwe .el-dialog__headerbtn {
  display: none !important;
}
</style>